import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import {
  RugbyUnionStatId,
  RugbyUnionSubParticipantStatId,
} from '@collector/sportsapi-client-legacy'

export const teamStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyUnionStatId.Tries },
  { sportStatId: RugbyUnionStatId.Conversions },
  { sportStatId: RugbyUnionStatId.DropGoals },
  { sportStatId: RugbyUnionStatId.Offloads },
  { sportStatId: RugbyUnionStatId.LineOutsWon },
  { sportStatId: RugbyUnionStatId.LineOutsLost },
  { sportStatId: RugbyUnionStatId.ScrumsWon },
  { sportStatId: RugbyUnionStatId.ScrumsLost },
  { sportStatId: RugbyUnionStatId.TurnoversWon },
  { sportStatId: RugbyUnionStatId.EntriesIntoTwentyTwo },
]

export const teamStatsAccordionIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyUnionStatId.YellowCards },
  { sportStatId: RugbyUnionStatId.RedCards },
  { sportStatId: RugbyUnionStatId.OrangeCards },
  { sportStatId: RugbyUnionStatId.Rucks },
  {
    sportStatId: RugbyUnionStatId.RucksEfficiency,
    format: { percent: true },
    name: 'Rucks Won (%)',
    edit: { disabled: true },
  },
  {
    sportStatId: RugbyUnionStatId.ScrumsEfficiency,
    format: { percent: true },
    name: 'Scrums Won (%)',
    edit: { disabled: true },
  },
  { sportStatId: RugbyUnionStatId.DropGoalsMissed },
]

export const playerStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyUnionSubParticipantStatId.PointsScored },
  { sportStatId: RugbyUnionSubParticipantStatId.Tries },
  { sportStatId: RugbyUnionSubParticipantStatId.Conversions },
  { sportStatId: RugbyUnionSubParticipantStatId.ConversionsMissed },
  { sportStatId: RugbyUnionSubParticipantStatId.PenaltyKickGoals },
  { sportStatId: RugbyUnionSubParticipantStatId.PenaltyKicksMissed },
  { sportStatId: RugbyUnionSubParticipantStatId.DropGoals },
  { sportStatId: RugbyUnionSubParticipantStatId.DropGoalsMissed },
  { sportStatId: RugbyUnionSubParticipantStatId.YellowCards },
  { sportStatId: RugbyUnionSubParticipantStatId.RedCards },
  { sportStatId: RugbyUnionSubParticipantStatId.OrangeCards },
  { sportStatId: RugbyUnionSubParticipantStatId.Appearance },
  { sportStatId: RugbyUnionSubParticipantStatId.FirstLineups },
]
